import { ErrorBox } from "@/components/error-handling/error-box";
import { LoadingOverlay } from "@/components/overlay";
import { useAppleOAuthRedirectPageBehavior } from "@/pages/apple-oauth-redirect/utils/behavior";
import { observer } from "mobx-react-lite";
import { FC } from "react";

export const AppleOAuthRedirectPage: FC = observer(() => {
  const state = useAppleOAuthRedirectPageBehavior();

  if (state.failedAt) {
    return <ErrorBox message="An unknown error occurred." />;
  }

  return <LoadingOverlay isVisible={true} />;
});
